export default defineNuxtRouteMiddleware((to, from) => {
  const app = useAppStore()
  const fat = useFatStore()

  // Try to find city slug from params
  const citySlug = (to.params.all && to.params.all?.length === 1)
    ? app.cities.find(city => city.slug.includes(to.params.all[0]))?.slug
    : ((to.params.all && to.params.all[1])
      ? app.cities.find(city => city.slug.includes(to.params.all[1]))?.slug
      : to.params?.city)

  // Get city by slug
  const city = useCityBySlug(citySlug)

  // Check if FAT date has passed
  if (citySlug && toDayjs().isAfter(fat.date, 'day')) {
    console.log('Update FAT date')
    fat.date = toDayjs().format('YYYY-MM-DD')
  }
  
  // Update FAT city ID
  if (city?.id > 0 && fat.city?.slug !== citySlug) {
    fat.cityId = city.id
  }

  // Reset FAT City ID for start page
  if (to.name === 'start' && to.query?.cityId === 'null') {
    fat.cityId = null
  }

  // Redirect Start if City ID is set
  if (to.name === 'start' && fat.cityId && to.query?.cityId !== 'null') {
    return navigateTo({ 
      path: `/${fat.city?.slug}`,
      query: to.query,
    })
  }

  // Reset pagination on City ID change
  if (to.query?.paged && to.params?.city !== from.params?.city) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        paged: undefined,
      }
    })
  }
})
